import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, finalize, map, Observable, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { DataService } from '../../services/data-api.service';
import { Action, Store } from '@ngrx/store';
import { selectProjectSearchRequest } from './projects.selector';
import {
  loadAllProjectsForSearchRequest,
  loadProjectsFailure,
  loadProjectsSuccess,
  searchProjectsSuccess
} from './projects.actions';
import { selectAllBrands } from '../brands';
import { UserInfoService } from 'src/app/services/user-info.service';
import { NotificationService } from 'src/app/services/notification.service';

/**
 * ProjectsEffects class is responsible for handling the side effects related to projects.
 * It contains methods to load active projects and search projects based on a request.
 */
@Injectable()
export class ProjectsEffects {
  /**
   * Effect to load all active projects.
   *
   * @returns An observable of the action to load all active projects.
   */
    constructor(
    private store: Store,
    private actions$: Actions,
    private dataService: DataService,
    private notificationService: NotificationService
  ) {}
  
  /**
   * Effect to load all projects for search request.
   * @returns An observable of actions.
   */
loadAllProjectsForSearchRequest$ = createEffect(
    (): Observable<Action> =>
      { return this.actions$.pipe(
        ofType(loadAllProjectsForSearchRequest),
        withLatestFrom(
          this.store.select(selectProjectSearchRequest),
          this.store.select(selectAllBrands)
        ),
        tap(() => this.notificationService.showSpinner()),
        // use switchMap so a new search cancels the previous one
        switchMap(([_, request, brands]) =>
          this.dataService.searchProject(request).pipe(
            map(response => searchProjectsSuccess({ request, response }) as Action),
            catchError(error => of(loadProjectsFailure({ error })) as Observable<Action>),
            finalize(() => this.notificationService.hideSpinner())
          )
        )
      )}
  );




}
